import { PropertyStats } from "../../domain/device/entities/properties";
import { PropertiesAPI } from "../../services/hcnApi";

export const getPropertyStats = async (
  propertyId: number
): Promise<PropertyStats> => {
  return PropertiesAPI.getFleetStats({ hotelId: propertyId });
};
